import React from 'react';
import { useTranslation } from '../utils/i18n';
import { useAuth } from '../contexts/AuthContext';

interface SuspendedAlertModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuspendedAlertModal: React.FC<SuspendedAlertModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation();
  const { configData } = useAuth();

  if (!isOpen) return null;

  const suspendedMessage = configData?.email_admin 
    ? t('home.suspended.messageWithEmail', { email: configData.email_admin })
    : t('home.suspended.message');

  return (
    <div className="modal-backdrop" style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%', 
      backgroundColor: 'rgba(0, 0, 0, 0.5)', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      zIndex: 1060 
    }}>
      <div className="modal-container" style={{ 
        backgroundColor: 'white', 
        borderRadius: '8px', 
        padding: '24px', 
        maxWidth: '500px', 
        width: '90%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}>
        <div className="modal-header" style={{ 
          marginBottom: '16px',
          paddingBottom: '12px',
          borderBottom: '1px solid #e0e0e0'
        }}>
          <h3 style={{ 
            margin: 0, 
            color: '#dc2626', 
            fontSize: '18px', 
            fontWeight: 'bold' 
          }}>
            {t('shared.warning')}
          </h3>
        </div>
        <div className="modal-body" style={{ 
          marginBottom: '24px',
          lineHeight: '1.5',
          color: '#333'
        }}>
          {suspendedMessage}
        </div>
        <div className="modal-footer" style={{ 
          display: 'flex', 
          justifyContent: 'flex-end' 
        }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            {t('shared.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspendedAlertModal;
